export function getClientTimeZone(defaultTz = 'UTC'): string {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (tz && isValidTimeZone(tz)) return tz;
  } catch {
    // ignore
  }
  return defaultTz;
}

/**
 * Checks for a valid IANA time zone string.
 * @param tz 
 * @returns 
 */
function isValidTimeZone(tz: string): boolean {
  try {
    // Will throw if tz is not a valid IANA zone
    new Intl.DateTimeFormat('en-US', { timeZone: tz }).format();
    return true;
  } catch {
    return false;
  }
}

/**
 * Format a server-sent UTC date string into the user's local browser time zone.
 *
 * @param date ISO string or Date
 * @param locale Optional BCP 47 locale (defaults to browser locale)
 */
export function formatClientLocalDate(
  date: string | Date,
  locale: string = navigator.language
): string {
  const d = typeof date === 'string' ? new Date(date) : date;

  return new Intl.DateTimeFormat(locale, {
    dateStyle: 'medium',
    timeStyle: 'short',
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone, // browser tz
  }).format(d);
}
